import { put, takeEvery, call, all, select } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'

// import company services
import { getCompanies, postCompany, putCompany, deleteCompany } from '../../services/company'

const getCurrentUser = state => state.user

export function* fetchCompanies() {
  try {
    const user = yield select(getCurrentUser)
    const { data } = yield call(() => getCompanies(user.token))
    yield put({
      type: actions.FETCH_COMPANIES_SUCCESS,
      data,
    })
  } catch (error) {
    yield put({ type: actions.FETCH_COMPANIES_ERROR, message: error.message })
  }
}

export function* setCompany(company) {
  try {
    const user = yield select(getCurrentUser)

    // ajusta los json
    company.payload.datetimedatajson = JSON.parse(company.payload.datetimedatajson)
    company.payload.sysdatajson = JSON.parse(company.payload.sysdatajson)
    company.payload.extradatajson = JSON.parse(company.payload.extradatajson)
    company.payload.operdatajson = JSON.parse(company.payload.operdatajson)
    company.payload.details = JSON.parse(company.payload.details)

    yield call(() => putCompany(user.token, company.payload))
    notification.success({
      message: 'Grabado exitoso',
      description: 'Se han guardado exitósamente los cambios',
    })
    yield put({
      type: actions.FETCH_COMPANIES,
    })
  } catch (error) {
    yield put({ type: actions.COMPANY_ERROR, message: error.message })
  }
}

export function* addCompany(company) {
  try {
    const user = yield select(getCurrentUser)

    // ajusta los json para que no se graben como string sino como objetos json en DB
    company.payload.extradatajson = JSON.parse(company.payload.extradatajson)
    company.payload.operdatajson = JSON.parse(company.payload.operdatajson)
    company.payload.details = JSON.parse(company.payload.details)

    yield call(() => postCompany(user.token, company.payload))
    notification.success({
      message: 'Grabado exitoso',
      description: 'Se ha agregado exitósamente el producto',
    })
    yield put({
      type: actions.FETCH_COMPANIES,
    })
  } catch (error) {
    yield put({ type: actions.COMPANY_ERROR, message: error.message })
  }
}

export function* delCompany(company) {
  try {
    const user = yield select(getCurrentUser)
    yield call(() => deleteCompany(user.token, company.payload.uid))
    notification.success({
      message: 'Borrado exitoso',
      description: 'Se ha eliminado exitósamente el producto',
    })
    yield put({
      type: actions.FETCH_COMPANIES,
    })
  } catch (error) {
    yield put({ type: actions.COMPANY_ERROR, message: error.message })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_COMPANIES, fetchCompanies),
    takeEvery(actions.COMPANY_SET, setCompany),
    takeEvery(actions.COMPANY_ADD, addCompany),
    takeEvery(actions.COMPANY_DEL, delCompany),
  ])
}
